/* Product-page clips: no media request before window.load, silent inline loops. */
(() => {
  const states = new Map();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let loaded = document.readyState === 'complete';
  const inView = state => {
    const rect = state.container.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
  };
  const setLabel = state => state.video.setAttribute('aria-label', `${state.video.paused ? 'Play' : 'Pause'} ${state.caption}`);
  const showPoster = (state, message = '') => {
    state.video.hidden = true;
    if (state.poster) state.poster.hidden = false;
    if (state.play) { state.play.hidden = !state.video.dataset.src; if (state.video.dataset.src) state.play.dataset.videoFallback = ''; }
    if (state.status) state.status.textContent = message;
  };
  const prepare = state => {
    if (!loaded || !state.video.dataset.src) return false;
    const source = state.video.dataset.src;
    if (state.video.getAttribute('src') !== source) {
      state.video.src = source;
      state.video.preload = 'metadata';
      state.video.load();
    }
    return true;
  };
  const start = async (state, manual = false) => {
    if (!prepare(state) || (!manual && (state.userPaused || reducedMotion.matches || document.hidden || !state.visible))) return;
    const attempt = ++state.attempt;
    state.video.muted = true;
    state.video.controls = false;
    state.video.hidden = false;
    if (state.poster) state.poster.hidden = true;
    if (state.play) state.play.hidden = true;
    if (state.status) state.status.textContent = '';
    try { await state.video.play(); }
    catch (error) {
      if (attempt !== state.attempt || (!manual && !state.visible)) return;
      showPoster(state, state.video.error ? 'Video could not load. Tap to try again.' : 'Tap to play the silent video.');
    }
  };
  const begin = state => {
    prepare(state);
    state.visible = inView(state);
    if (reducedMotion.matches) showPoster(state);
    else start(state);
    if (!state.observer && 'IntersectionObserver' in window) {
      state.observer = new IntersectionObserver(entries => {
        state.visible = entries[0].isIntersecting;
        if (state.visible) start(state);
        else { state.attempt++; state.video.pause(); }
      }, {threshold:0.01});
      state.observer.observe(state.container);
    }
  };
  const register = (video, options) => {
    if (!video || states.has(video)) return;
    const state = {video, ...options, visible:false, userPaused:false, attempt:0};
    states.set(video, state);
    video.muted = true;
    video.defaultMuted = true;
    video.controls = false;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('loop', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('role', 'button');
    video.setAttribute('tabindex', '0');
    video.setAttribute('title', 'Tap to pause or play');
    if (state.poster) video.poster = state.poster.getAttribute('src') || '';
    if (state.play) state.play.hidden = true;
    const toggle = () => {
      if (!video.paused) { state.userPaused = true; state.attempt++; video.pause(); }
      else { state.userPaused = false; start(state, true); }
    };
    video.addEventListener('click', toggle);
    video.addEventListener('keydown', event => {
      if (event.key === ' ' || event.key === 'Enter') { event.preventDefault(); toggle(); }
    });
    video.addEventListener('play', () => { if (state.poster) state.poster.hidden = true; if (state.play) state.play.hidden = true; setLabel(state); });
    video.addEventListener('pause', () => setLabel(state));
    video.addEventListener('error', () => { state.attempt++; showPoster(state, 'Video could not load. Tap to try again.'); });
    state.play?.addEventListener('click', () => { state.userPaused = false; start(state, true); });
    setLabel(state);
    if (loaded) begin(state);
  };
  const refresh = video => {
    const state = states.get(video);
    if (!state) return;
    state.attempt++;
    state.userPaused = false;
    state.caption = video.dataset.caption || state.caption;
    state.visible = inView(state);
    if (state.poster) video.poster = state.poster.getAttribute('src') || '';
    if (loaded) { if (reducedMotion.matches) { prepare(state); showPoster(state); } else start(state); }
  };
  window.HolistPostloadVideo = {register, refresh};
  if (!loaded) window.addEventListener('load', () => { loaded = true; states.forEach(begin); }, {once:true});
  document.addEventListener('visibilitychange', () => states.forEach(state => {
    if (document.hidden) { state.attempt++; state.video.pause(); }
    else if (loaded) { state.visible = inView(state); start(state); }
  }));
  reducedMotion.addEventListener?.('change', () => states.forEach(state => {
    if (reducedMotion.matches) { state.attempt++; state.video.pause(); }
    else if (loaded) start(state);
  }));
})();
